import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

import PageShell from "../../shared/page-shell/page-shell.tsx";
import { CelebrationBanners } from "./components/celebration-banners/celebration-banners.tsx";
import { useTrainingSessions } from "../../../hooks/use-training-sessions.ts";
import { QuickActions } from "./components/quick-actions/quick-actions.tsx";
import { AttendanceCard } from "./components/attendance-card/attendance-card.tsx";
import { MyProjects } from "./components/my-projects/my-projects.tsx";
import { LeaveBalanceOverviewCard } from "./components/leave-balance-overview-card/leave-balance-overview-card.tsx";
import { TeamAvailabilityCard } from "./components/team-availability-card/team-availability-card.tsx";
import { TrainingDevelopmentCard } from "./components/training-development-card/training-development-card.tsx";
import AttendanceAnalyticsCard from "./components/attendance-analytics/attendance-analytics-card.tsx";

import TimesheetSummaryCard from "./components/timesheet-summary-card/timesheet-summary-card.tsx";
import ActionCenterCard from "./components/action-center/action-center-card.tsx";
import Guard from "../../../lib/rbac/guard.tsx";
import { useUser } from "../../../lib/rbac/useUser.ts";
import { employeeFlag } from "../../../../constants/employeeFlag.js";
import { API_IS_SYSTEM_ASSIGNED } from "../../../../config/Endpoints.js";
import { getApi } from "../../../utils/api.ts";

const ATTENDANCE_HIDDEN_LOCATIONS = new Set(["CCI_US", "CCI_UK"]);

type SystemAssignmentResponse = {
  isSystemAssigned?: boolean;
};

export default function MainDashboard() {
  const { data: trainingSessions } = useTrainingSessions();
  const user = useUser();
  const accessToken = Cookies.get("accessToken");
  const [isSystemAssigned, setIsSystemAssigned] = useState(false);
  const hideAttendanceCards =
    user?.isRemote === true ||
    (user?.location != null &&
      ATTENDANCE_HIDDEN_LOCATIONS.has(user.location));

  const hideLeaveBalanceOverview =
    user?.location === employeeFlag.CCI_US;

  useEffect(() => {
    const checkSystemAssigned = async () => {
      try {
        const res = await getApi<SystemAssignmentResponse>(
          API_IS_SYSTEM_ASSIGNED,
          accessToken,
        );
        setIsSystemAssigned(Boolean(res?.data?.isSystemAssigned));
      } catch {
        setIsSystemAssigned(false);
      }
    };

    void checkSystemAssigned();
  }, [accessToken]);

  return (
    <PageShell>
      <div className="container-fluid p-0">
        <div className="mb-4">
          <CelebrationBanners trainingSessions={trainingSessions} />
        </div>
        <div className="mb-4">
          <QuickActions />
        </div>

        {/* Row Layout */}
        <div className="row g-3 mb-4 align-items-stretch">
          {!hideAttendanceCards && (
            <div className="col-md-4 d-flex">
              <AttendanceCard isSystemAssigned={isSystemAssigned} />
            </div>
          )}

          <div className="col-12 col-md-4 d-flex">
            <TimesheetSummaryCard />
          </div>

          {!hideAttendanceCards && (
            <div className="col-md-4 d-flex">
              <AttendanceAnalyticsCard />
            </div>
          )}
          <Guard permission="dashboard-action-center:access">
            <div className="col-md-6 d-flex">
              <ActionCenterCard />
            </div>
          </Guard>
          <div className="col-12 col-md-6 d-flex">
            <MyProjects />
          </div>



          {!hideLeaveBalanceOverview ? (
            <div className="mb-4">
              <LeaveBalanceOverviewCard />
            </div>
          ) : null}
          <div className="col-md-6 d-flex">
            <TrainingDevelopmentCard sessions={trainingSessions} />
          </div>
          <div className="col-md-6 d-flex">
            <TeamAvailabilityCard />
          </div>

        </div>
      </div>
    </PageShell>
  );
} 